import NotFound from 'components/shared/NotFound';
import React from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';

import Show from './Show';

function Invitations() {
  return (
    <Routes>
      <Route path=":id" element={<Show />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Invitations;
